module.exports = __webpack_public_path__ + "static/media/dreamwidth.83303465.svg";